'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Certificate Verification', href: '/certificate-search-page' },
  { label: 'Admin Panel', href: '/admin-login' },
];

export default function PublicHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-card shadow-elevated border-b border-border' : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2.5">
            <div className="flex flex-col leading-tight">
              <span className="font-bold text-base text-primary tracking-tight">
                MegaOSH Certification (MOC Certification)
              </span>
              <span className="text-[10px] font-medium text-muted-foreground tracking-widest uppercase">
                ISO Certification Body
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks?.map(link => (
              <Link
                key={`nav-${link?.href}`}
                href={link?.href}
                className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-primary hover:bg-secondary rounded-lg transition-all duration-150"
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              href="/certificate-search-page"
              className="btn-accent text-sm"
            >
              Verify Certificate
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-secondary transition-colors"
            onClick={() => setMobileOpen(o => !o)}
            aria-label="Toggle mobile menu"
          >
            {mobileOpen ? (
              <XMarkIcon className="w-5 h-5 text-foreground" />
            ) : (
              <Bars3Icon className="w-5 h-5 text-foreground" />
            )}
          </button>
        </div>
      </div>
      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-card border-t border-border animate-slide-up">
          <nav className="px-6 py-4 flex flex-col gap-1">
            {navLinks?.map(link => (
              <Link
                key={`mobile-nav-${link?.href}`}
                href={link?.href}
                className="px-3 py-2.5 text-sm font-medium text-muted-foreground hover:text-primary hover:bg-secondary rounded-lg transition-all duration-150"
                onClick={() => setMobileOpen(false)}
              >
                {link?.label}
              </Link>
            ))}
            <div className="mt-2 pt-2 border-t border-border">
              <Link
                href="/certificate-search-page"
                className="btn-accent w-full justify-center"
                onClick={() => setMobileOpen(false)}
              >
                Verify Certificate
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}